import React, {useState} from 'react';
import {Button, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow,} from "@mui/material";
import TableHeader from "../layout/table/TableHeader";
import NoDataLabel from "../layout/NoDataLabel";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ModalDelete from "../layout/ModalDelete";
import {useNavigate} from "react-router-dom";
import Constants from "../../../utils/constants.js";
import TypologieLavageBadge from "../layout/TypologieLavageBadge.js";
import Loader from "../layout/loading/loader.js";

function TypologiesLavageTable({typologies, onDelete}) {
    const navigate = useNavigate();
    const [label, setLabel] = useState("");
    const [objectToDelete, setObjectToDelete] = useState(null);
    const [open, setOpen] = useState(false);
    const [currentTypologie, setCurrentTypologie] = useState(null);

    const headCells = [
        {id: 'libelle', label: 'Libellé'},
    ];

    const openDeleteConfirmModal = (t) => {
        setCurrentTypologie(t);
        setLabel("Êtes-vous sûr de vouloir supprimer la typologie : ");
        setObjectToDelete(t.libelle);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentTypologie(null);
    };

    const handleEditClick = (id) => {
        navigate(Constants.APP_ROUTE_ADMIN_TYPOLOGIES_EDIT.replace(':id', id));
    };

    const handleDelete = () => {
        onDelete(currentTypologie);
        handleClose();
    };

    if (typologies === null) return <Loader/>;

    return (
        <>
            <TableContainer component={Paper} className={"mt-2"}>
                <Table aria-label="typologies table" size="small">
                    <TableHeader headCells={headCells}/>
                    <TableBody>
                        {typologies && typologies.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={2} align={"center"}>
                                    <NoDataLabel label={"Il n'y a encore aucune typologie de lavage enregistrée"}/>
                                </TableCell>
                            </TableRow>
                        }
                        {typologies && typologies.map((t) => (
                            <TableRow key={t?.id}
                                      hover
                                      onClick={() => handleEditClick(t?.id)}
                                      style={{cursor: 'pointer'}}>
                                <TableCell>
                                    <TypologieLavageBadge typologie={{libelle: t?.libelle, couleur: t?.couleur}}/>
                                </TableCell>
                                <TableCell>
                                    <Stack direction={"row"} spacing={2} justifyContent={"end"}>
                                        <Button color="secondary" size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleEditClick(t.id)
                                                }}
                                                startIcon={<ModeEditOutlineOutlinedIcon/>}>
                                            Éditer
                                        </Button>
                                        <Button color="error" size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openDeleteConfirmModal(t)
                                                }}
                                                startIcon={<CloseOutlinedIcon/>}>
                                            Supprimer
                                        </Button>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <ModalDelete
                label={label}
                onClose={handleClose}
                open={open}
                objectToDelete={objectToDelete}
                selectedValue={currentTypologie}
                onDelete={handleDelete}
            />
        </>
    );
}

export default TypologiesLavageTable;
